import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './How.module.scss';

export const HowStepTwo = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.howLeftSection}>
        <span className={styles.howStepLeft_1}>How</span>
        <span className={styles.howStepLeft_2}>does</span>
        <span className={styles.howStepLeft_3}>it work?</span>
      </div>
    }
    rightContent={
      <div className={styles.howStepContentWrapper}>
        <ul>
          <li style={{ marginBottom: 20 }}>
            On TransparenTerra, businesses can calculate their ESG scores, buy offset certificates,
            attract ESG investors, leverage expert consulting to improve their business
            sustainability, and increase their users’ loyalty.
          </li>
          <li>
            Experts can provide consultations, host webinars, organize conferences, issue
            certificates, support investors with proper assignments for sustainable investments,
            blog and share their opinions, invite other experts, investors, and businesses to the
            community, and expand their network.
          </li>
        </ul>
      </div>
    }
  />
);
